import cx from 'classnames';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

import './CompanyDropdownLimitedAccess.css';

type Props = {
  className?: string;
};

export const CompanyDropdownLimitedAccess = ({ className }: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className={cx('CompanyDropdownLimitedAccess', className)}>
      <h3 className="text-content-primary title-m">
        {t('limitedAccess.headerReviewingContractTitle')}
      </h3>
      <p className="text-content-primary body-s">
        {t('limitedAccess.headerReviewingContract')}
      </p>
    </div>
  );
};
